/**
 * prepUtils.js — chef-prep timing helpers (pure).
 */

export function normalizeTimeMap(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function getPrepSummary(source) {
  return {
    timeMin: source?.prepTimeMin ?? null,
    source: source?.prepSource || null,
    completedAt: source?.prepCompletedAt || null,
    itemMs: normalizeTimeMap(source?.chefDoneMs),
  };
}

export function getPrepTrackingPatch(prepSummary, fallbackMins, fallbackCompletedAt) {
  if (prepSummary.timeMin != null) {
    return {
      prepCompletedAt: prepSummary.completedAt || fallbackCompletedAt,
      prepTimeMin: prepSummary.timeMin,
      prepSource: prepSummary.source || 'chef',
      ...(Object.keys(prepSummary.itemMs).length > 0 ? { chefDoneMs: prepSummary.itemMs } : {}),
    };
  }
  return {
    prepCompletedAt: fallbackCompletedAt,
    prepTimeMin: fallbackMins,
    prepSource: 'completion',
  };
}

export function getPackGapMin(source) {
  const prepMin = source?.prepTimeMin ?? null;
  const doneMin = source?.timeTakenMin ?? null;
  if (prepMin == null || doneMin == null) return null;
  return Math.max(0, doneMin - prepMin);
}
